require(['jquery'], function($){

	"use strict";

	var PLUGIN_NAME = "universalPagination";
	var PLUGIN_VERSION = "v1.0";

	var	DEFAULTS = {
		// getter settings
		nextPageButtonSelector: 'a.next',
		listSelector: '',
		itemSelector: 'li',
		paginationSelector: '.pagination',

		// render settings
		wrapperClass: 'pagination-wrapper',
		nextClass: '',
		nextWrapperClass: '',
		infinitePagination: true,
		numberedPagination: true,
		enableAutoscroll: true,
		listTopOffset: 25,
		autoPreloadHistory: true,

		// events
		onAfterPagedContentRendered: 'UP_AFTER_CONTENT_RENDERED',
		onAfterPageChanged: 'UP_AFTER_PAGE_CHANGED',

		// i18n
		lang: 'en',
		messages: {
			cs: {
				next: 'Načíst další',
				loading: 'Nahrává se…'
			},
			en: {
				next: 'Load more',
				loading: 'Loading…'
			},
			de: {
				next: 'Mehr',
				loading: 'Wird geladen…'
			},
			es: {
				next: 'Más',
				loading: 'Se está grabando…'
			},
			it: {
				next: 'Di più',
				loading: 'Sto caricando…'
			},
			ru: {
				next: 'Подробнее',
				loading: 'Скачивается'
			},
			ko: {
				next: '더 보기',
				loading: '로드 중입니다'
			},
			zh: {
				next: '更多',
				loading: '正在打开...'
			},
			ja: {
				next: '次へ',
				loading: '記録しています'
			}
		}
	};

	/**
	 *
	 * @param element
	 * @param options
	 * @constructor
	 */
	var UniversalPagination = function ( element, options ) {
		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;

		this.$infiniteNextWrapper = null;
		this.$wrapper = null;

		this.debugEnabled_ = false;

		this.initialise_();
	};

	/**
	 * Init function - read options.cookieName status,
	 * @private
	 */
	UniversalPagination.prototype.initialise_ = function() {
		this.createWrapper_();
		this.i18n = this.options.messages[this.options.lang];
		this.historySupported = history && history.replaceState;

		this.$list = $(this.options.listSelector);

		if (this.options.infinitePagination) {
			this.applyInfinitePagination_();
		}

		if (this.options.numberedPagination) {
			this.applyNumberedPagination_();
		}
		this.uniqueId = this.getDomId_(this.$t);

		if (this.options.autoPreloadHistory) {
			this.preloadHistoryStateIfAny();
		}

		this.debug_('instance object', this);
	};

	/**
	 * creates and stores wrapper for further use
	 * @private
	 */
	UniversalPagination.prototype.createWrapper_ = function() {
		// ugly way, stupid stupid stupid jQuery - can wrap only with 'HTML string', not with jQuery object
		this.$t.wrap('<div class="'+this.options.wrapperClass+'"></div>');
		this.$wrapper = this.$t.parent('.' + this.options.wrapperClass);
	};

	/**
	 * creates infinte pagination - renders button, handles loading
	 * @private
	 */
	UniversalPagination.prototype.applyInfinitePagination_ = function() {
		this.renderInfinitePaginationButton_(this.$wrapper);
		this.bindEventInfinitePaginationButton_();
	};

	/**
	 * reads next button from given pagination, renders custom button
	 * @private
	 */
	UniversalPagination.prototype.renderInfinitePaginationButton_ = function(htmlSet) {
		if (this.$infiniteNextWrapper instanceof $) {
			if (this.$infiniteNextLink) this.$infiniteNextLink.off();
			this.$infiniteNextWrapper.remove();
		}
		var $nextLink = $(htmlSet).find(this.options.nextPageButtonSelector);
		if ($nextLink.size() > 0) {
			this.$infiniteNextWrapper = $('<p class="'+this.options.nextWrapperClass+'"></p>').appendTo(this.$wrapper);
			this.$infiniteNextLink = $('<a class="'+this.options.nextClass+'" href="'+$nextLink.attr('href')+'">'+this.i18n.next+'</a>').appendTo(this.$infiniteNextWrapper);
		}
	};

	/**
	 * handles ajax request to the next page
	 * @private
	 */
	UniversalPagination.prototype.bindEventInfinitePaginationButton_ = function() {
		var self_ = this;
		if (this.$infiniteNextLink) {
			this.$infiniteNextLink.on('click', function(event) {
				event.preventDefault();
				$(event.currentTarget).html(self_.i18n.loading);
				var url = $(event.currentTarget).attr('href');
				$.get(url, function(response) {
					self_.parseAndRenderResponse_(response, false, false, 'infinite');
					self_.reinitPagination_(response, url, true);
				});
			});
		}
	};

	/**
	 * parses html response, finds list items and pagination
	 * @param response
	 * @param clearList
	 * @param scrollTo
	 * @param type
	 * @private
	 */
	UniversalPagination.prototype.parseAndRenderResponse_ = function(response, clearList, scrollTo, type) {
		this.debug_('parsing response', clearList);
		var $items = $(response).find(this.options.listSelector + ' ' + this.options.itemSelector);
		if (clearList) {
			this.$list.empty();
		}
		this.$list.append($items);

		this.$t.trigger(this.options.onAfterPagedContentRendered, [this, type]);

		if (this.options.enableAutoscroll && scrollTo) {
			$('html, body').animate({ scrollTop: this.$list.offset().top - this.options.listTopOffset }, 200);
		}
	};

	/**
	 * find pagination in response, than replace old one with this one and reinitialize InfinitePaginationButton if needed
	 * @private
	 */
	UniversalPagination.prototype.reinitPagination_ = function(response, url, firePageChangedTrigger) {
		var $newPagination = $(response).find(this.options.paginationSelector);
		this.$t.html($newPagination.html()); // can't use .replaceWith() due to this.$t reference
		if (this.options.infinitePagination) {
			this.applyInfinitePagination_();
		}

		// save url to page history
		var state = history.state || {
				universalPagination: {}
			};

		state.universalPagination[this.uniqueId] = {
			url: url,
			pagination: this.options.paginationSelector
		};

		this.saveStateToHistory_(state);

		// trigger event for external use
		if (firePageChangedTrigger) {
			this.$t.trigger(this.options.onAfterPageChanged, [this, state, this.uniqueId]);
		}
	};

	/**
	 * binds click event to pagination links - use ajax to load pages
	 * @private
	 */
	UniversalPagination.prototype.applyNumberedPagination_ = function() {
		var self_ = this;
		self_.debug_('numbered pagination applied to anchors in', this.$t);
		this.$t.on('click', 'a', function(event) {
			self_.debug_('numbered pagination clicked');
			event.preventDefault();
			var url = $(event.currentTarget).attr('href');
			$.get(url, function(response) {
				self_.parseAndRenderResponse_(response, true, true, 'numbers');
				self_.reinitPagination_(response, url, true);
			});
		});
	};

	/**
	 * gets full path in DOM - unique
	 * @private
	 */
	UniversalPagination.prototype.getDomId_ = function(el) {
		var path = $(el).parents().addBack();
		var fullPath = path.get().map(function (item) {
			var self = $(item),
				id = item.id ? '#' + item.id : '',
				clss = item.classList.length ? item.classList.toString().split(' ').map(function (c) {
					return '.' + c;
				}).join('') : '',
				name = item.nodeName.toLowerCase();

			if (clss.indexOf('partialUpdateDynamicContainer') > -1) {
				return '';
			}

			if (name === 'html' || name === 'body') {
				return name;
			}
			return name + id + clss;

		}).join(' > ');
		fullPath = fullPath.replace(/>  >/ig, '>');

		return 'h' + String(this.hashCode_(fullPath));
	};

	/**
	 * make some kind of hash
	 * @param str
	 * @returns {number}
	 * @private
	 */
	UniversalPagination.prototype.hashCode_ = function(str) {
		var hash = 0, i, chr, len;
		if (str.length == 0) return hash;
		for (i = 0, len = str.length; i < len; i++) {
			chr   = str.charCodeAt(i);
			hash  = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	};

	/**
	 * save state to actual history state
	 * @param data
	 * @private
	 */
	UniversalPagination.prototype.saveStateToHistory_ = function(data) {
		if (this.historySupported) {
			history.replaceState(data, document.title, window.location.href);
		}
	};

	/**
	 *
	 * @returns {boolean}
	 */
	UniversalPagination.prototype.preloadHistoryStateIfAny = function() {

		var itemProperties = null,
			self_ = this;
		if (!this.historySupported) {
			return false;
		}

		if (history && history.state && history.state.universalPagination) {
			for (var item in history.state.universalPagination) {
				if (!history.state.universalPagination.hasOwnProperty(item)) { return false; }

				itemProperties = history.state.universalPagination[item];
				// if pagination exists and its hashed dom path equals to the history item id
				if (item == this.uniqueId) {
					this.loadAndRenderSpecifiedPage(itemProperties.url);
				}
			}
		}

		return true;
	};

	UniversalPagination.prototype.loadAndRenderSpecifiedPage = function(url) {
		var self_ = this;
		$.get(url, function(response) {
			self_.parseAndRenderResponse_(response, true, false, 'history');
			self_.reinitPagination_(response, url, false);
		});
	};

	UniversalPagination.prototype.debug_ = function() {
		if (this.debugEnabled_) {
			console.log(arguments);
		}
	};

	/**
	 * returns class instance by selector - for external usage
	 * @param selector
	 * @returns {*|jQuery}
	 */
	UniversalPagination.prototype.getPaginationInstance = function(selector) {
		return $(selector).data('plugin_' + PLUGIN_NAME);
	};

	/**
	 * getter for uniqueId of the instance
	 * @returns {*}
	 */
	UniversalPagination.prototype.getUniqueId = function() {
		return this.uniqueId;
	};

	var API = {
		preloadHistoryStateIfAny: UniversalPagination.prototype.preloadHistoryStateIfAny,
		loadAndRenderSpecifiedPage: UniversalPagination.prototype.loadAndRenderSpecifiedPage,
		getUniqueId: UniversalPagination.prototype.getUniqueId
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new UniversalPagination(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};

	/**
	 * setDefaults with $.googlemap.setDefaults();
	 */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function(newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};

});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.universalPagination.js